// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__C4rxf","fileBtn":"File_fileBtn__2rmiZ","closeBtn":"File_closeBtn__3o_Xn","fileSelected":"File_fileSelected__YVqqX","disabled":"File_disabled__1RBRV"};